import api from './api';

export const getMyTasks = (params = {}) => api.get('/me/tasks', { params });
export const getMyCalendar = (params = {}) => api.get('/me/calendar', { params });
export const getMyFiles = (params = {}) => api.get('/me/files', { params });
export const getMyAttention = () => api.get('/me/attention');
